// app/src/dashboard/widgets/ResizeHandle.tsx
import type { HandlePosition } from "./useWidgetResize";

interface ResizeHandleProps {
  position: HandlePosition;
  ariaLabel: string;
  isResizing: boolean;
  onPointerDown: (e: React.PointerEvent<HTMLElement>) => void;
}

export default function ResizeHandle({
  position,
  ariaLabel,
  isResizing,
  onPointerDown,
}: ResizeHandleProps) {
  const active = isResizing ? "opacity-100" : "opacity-0 group-hover:opacity-100";

  if (position === "right") {
    return (
      <div
        role="button"
        tabIndex={-1}
        aria-label={ariaLabel}
        onPointerDown={onPointerDown}
        className={`absolute right-0 inset-y-0 w-3 z-30 cursor-col-resize select-none flex items-center justify-center transition-opacity ${active}`}
      >
        <div className={`w-1 h-8 rounded-full ${isResizing ? "bg-primary" : "bg-primary/60"}`} />
      </div>
    );
  }

  if (position === "bottom") {
    return (
      <div
        role="button"
        tabIndex={-1}
        aria-label={ariaLabel}
        onPointerDown={onPointerDown}
        className={`absolute bottom-0 inset-x-0 h-3 z-30 cursor-row-resize select-none flex items-center justify-center transition-opacity ${active}`}
      >
        <div className={`h-1 w-8 rounded-full ${isResizing ? "bg-primary" : "bg-primary/60"}`} />
      </div>
    );
  }

  // corner
  return (
    <div
      role="button"
      tabIndex={-1}
      aria-label={ariaLabel}
      onPointerDown={onPointerDown}
      className={`absolute bottom-0 right-0 w-5 h-5 z-30 cursor-nwse-resize select-none flex items-end justify-end pb-1 pr-1 transition-opacity ${active}`}
    >
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        className={isResizing ? "text-primary" : "text-primary/70"}
        fill="currentColor"
      >
        {/* 3-dot diagonal grip */}
        <circle cx="8" cy="8" r="1.5" />
        <circle cx="4.5" cy="8" r="1.5" />
        <circle cx="8" cy="4.5" r="1.5" />
      </svg>
    </div>
  );
}
